module.exports = __webpack_public_path__ + "img/1920x325.23834a5b.png";